import type { PatentProfileWithMatchedTechFeature } from '../types';

/**
 * 专利查新特征对比相似服务服务
 */
export interface FtoReportSimilarService {
    /**
     * 更新查新相似列表
     */
    updateNoveltySimilarList(techFeatures: PatentProfileWithMatchedTechFeature[]): Promise<PatentProfileWithMatchedTechFeature[]>;

    /**
     * 获取技术特征对比得分
     */
    getFeatureComparison(pns: string[]): Promise<PatentProfileWithMatchedTechFeature[]>;
}

export const FtoReportSimilarService = Symbol.for('FtoReportSimilarService');
